import { render, staticRenderFns } from "./AdvantageBloc.vue?vue&type=template&id=04d28f34&scoped=true&"
import script from "./AdvantageBloc.vue?vue&type=script&lang=js&"
export * from "./AdvantageBloc.vue?vue&type=script&lang=js&"
import style0 from "./AdvantageBloc.vue?vue&type=style&index=0&id=04d28f34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d28f34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37556953/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04d28f34')) {
      api.createRecord('04d28f34', component.options)
    } else {
      api.reload('04d28f34', component.options)
    }
    module.hot.accept("./AdvantageBloc.vue?vue&type=template&id=04d28f34&scoped=true&", function () {
      api.rerender('04d28f34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/fragments/AdvantageBloc.vue"
export default component.exports